import "../../../styles/portfolio-scroll.css";
import useScrollAnimation from "../../../hooks/useScrollAnimation";
import "../../../styles/scroll-animations.css";

const PortfolioSection = () => {
    const [headerRef, headerVisible] = useScrollAnimation({ threshold: 0.3 });
    const [scrollRef, scrollVisible] = useScrollAnimation({ threshold: 0.1 });

    const projects = [
        {
            id: 1,
            title: "Mobile App for IM Academy",
            description: "Blandit turpis scelerisque felis nunc odio cras porttitor vitae quis diam blandit eget purus lorem urna id mattis id ut magnis velit.",
            image: "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/6423642821680f903a1d5ef5_editorial-design-for-haus-thumbnail-image-darkstudio-x-webflow-template.jpg",
            href: "/projects/im-academy"
        },
        {
            id: 2,
            title: "Customer portal for Real Rise",
            description: "Amet dui pharetra hac tincidunt mi rhoncus viverra sagittis tincidunt viverra bibendum non nunc bibendum maecenas nec volutpat diam.",
            image: "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/64236403e8658c5a5dbd2ae3_package-design-for-sezane-thumbnail-image-darkstudio-x-webflow-template.jpg",
            href: "/projects/real-rise"
        },
        {
            id: 3,
            title: "Full Suite for 4you Attorneys",
            description: "Viverra non nibh pretium in gravida ornare nisl quis a eu commodo massa amet enim quam mi commodo orci vitae enim scelerisque.",
            image: "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/642363c47c68c82b957e2b6d_billboard-design-for-sezane-thumbnail-image-darkstudio-x-webflow-template.jpg",
            href: "/projects/4you-attorneys"
        },
        {
            id: 4,
            title: "Full Suite for MyAccidentExperts",
            description: "Quis consectetur vestibulum at amet pulvinar lacus sed molestie non proin ultricies varius aliquam dolor sed consequat odio ut.",
            image: "https://cdn.prod.website-files.com/6421b2d2f79c9c077b222ffc/6423614f099312f269d37119_stationary-design-for-globex-thumbnail-image-darkstudio-x-webflow-template.jpg",
            href: "/projects/myaccidentexperts"
        }
    ];

    return (
        <div className="section overflow-hidden">
            <div className="container-default w-container">
                <div 
                    ref={headerRef}
                    data-w-id="a0fc02d6-0127-1bab-0029-7e99b2e43e93"
                    className={`title-left---content-right mg-bottom-48px scroll-animate scroll-fade-right ${headerVisible ? 'visible' : ''}`}
                >
                    <div className="inner-container _845px">
                        <div className="big-font-title display-2---size">Projects</div>
                        <h2 className="display-2 mg-bottom-0">Our latest work</h2>
                    </div>
                    <a href="/projects"
                       className="btn-secondary white w-button">Browse all projects</a>
                </div>
            </div>
            
            {/* Horizontal Scroll Container */}
            <div 
                ref={scrollRef}
                className={`portfolio-scroll-wrapper scroll-animate scroll-fade-up scroll-delay-2 ${scrollVisible ? 'visible' : ''}`}
            >
                <div className="portfolio-scroll-container">
                    {projects.map((project) => (
                        <a 
                            key={project.id} 
                            href={project.href}
                            className="portfolio-scroll-card"
                        >
                            <div className="portfolio-scroll-image-wrapper">
                                <img
                                    src={project.image}
                                    alt={project.title}
                                    className="portfolio-scroll-image"
                                />
                            </div>
                            <div className="portfolio-scroll-content">
                                <div className="portfolio-scroll-title-row">
                                    <h3 className="display-3 mg-bottom-0">{project.title}</h3>
                                    <div className="card-arrow-wrapper">
                                        <div className="line-square-icon"></div>
                                    </div>
                                </div>
                                <p className="color-neutral-300 mg-bottom-0">{project.description}</p>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    )

}

export default PortfolioSection;
